<template>
  <v-container fluid v-resize="onResize" class="px-0 py-0">
    <v-card :height="componentHeight" elevation="0" class="overflow-hidden" :width="componentWidth">
      <v-system-bar height="24">
        <v-spacer></v-spacer>
        <v-chip x-small v-if="!!editedItem">created: {{ editedItem.created_by_name }}</v-chip>
        <v-chip x-small v-if="!!editedItem && !!editedItem.created_on">
          {{ editedItem.created_on | moment("DD.MM.YY HH:mm") }}
        </v-chip>
        <v-chip x-small v-if="!!editedItem">edited: {{ editedItem.edited_by_name }}</v-chip>
        <v-chip x-small v-if="!!editedItem && !!editedItem.edited_on">{{
            editedItem.edited_on | moment("DD.MM.YY HH:mm")
          }}
        </v-chip>
        <v-chip x-small v-if="!!editedItem">{{ editedItem.uid }}</v-chip>
        <BaseDeleteIcon
            v-if="!!editedItem"
            v-model="editedItem.deleted"
            :readonly="readonly"
            :show_label="false"
        ></BaseDeleteIcon>
      </v-system-bar>
      <v-sheet
          :height="componentHeight - 70"
          class="my-0 py-5 px-3"
          :max-width="componentWidth">
        <slot
            name="body"
            :editedItem="editedItem"
            :slotHeight="componentHeight - 70"
            :readonly="readonly"
        >
        </slot>
      </v-sheet>
      <v-toolbar height="44" class="mb-auto">
        <slot
            name="action.left"
            :editedItem="editedItem"
            :readonly="readonly"
        >
        </slot>
        <v-spacer></v-spacer>
        <slot name="action.middle">
          <v-pagination
              v-if="!!pageLength"
              v-model="currentPage"
              class="my-4"
              :length="pageLength"
              :total-visible="pageTotalVisible"
              @input="onSave(); $emit('pagination', currentPage)"
          ></v-pagination>
        </slot>
        <v-spacer></v-spacer>
        <v-btn
            v-if="!noBtnCancel"
            text
            elevation="3"
            class="mx-1"
            @click="onCancel"
        >
          {{ textCancel }}
        </v-btn>
        <v-btn
            text
            elevation="3"
            class="mx-1"
            @click="onSave()"
            :disabled="readonly"
        >
          {{ textSave }}
        </v-btn>
      </v-toolbar>
    </v-card>
  </v-container>
</template>

<script>
import commonFunction from "@/commonFunction/commonFunction"
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import {debounce} from "debounce";
import {v4 as uuidv4} from "uuid";


export default {
  name: 'BaseDetailItem',
  props: {
    value: {default: null},
    valueInitFunction: {
      default: function () {
        return {uid: uuidv4()}
      }
    },
    height: {default: null},
    width: {width: null},
    readonly: {type: [Boolean], default: false},
    textSave: {default: 'Save'},
    textCancel: {default: 'Cancel'},
    page: {default: null},
    pageTotalVisible: {default: 7},
    pageLength: {default: null},
    noBtnCancel: {default: false},
  },

  components: {
    BaseDeleteIcon,
  },

  computed: {
    componentHeight() {
      if (!!this.height) {
        this.$emit('resize', this.height)
        return this.height
      }
      const heightOffset = 30
      this.$emit('resize', this.windowSize.y * 0.9 - heightOffset)
      return this.windowSize.y * 0.9 - heightOffset
    },
    componentWidth() {
      if (!!this.width)
        return this.width
      return this.windowSize.x
    },
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.editedItem = newValue
      },
      deep: true
    },
    page: {
      handler(newValue, oldValue) {
        // console.log('watch page', newValue, oldValue)
        this.currentPage = newValue
      },
      deep: false
    }
  },

  methods: {
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight};
    },

    onSave() {
      // console.log('onSave', this.editedItem)
      this.$emit('save', this.editedItem)
      this.editedItem = this.valueInitFunction
    },

    onCancel() {
      this.$emit('cancel', null)
      this.editedItem = this.valueInitFunction
    },

  },

  async mounted() {
    this.editedItem = this.value
    this.currentPage = this.page
    this.onResize()
  },

  data() {
    return {
      editedItem: {},
      windowSize: {x: 0, y: 0,},
      currentPage: 1,
    }
  }
}
</script>

<style scoped lang="scss">
</style>

<i18n>
{
}
</i18n>
